@charset "UTF-8";
@import "https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&display=swap";

/* src/app/components/login/login.component.scss */
:host {
  --oks-navy: #092c3f;
  --oks-navy-600: #082535;
  --oks-slate-300: #324f5f;
  --oks-slate-200: #84959f;
  --oks-slate-100: #adb9bf;
  --oks-slate-50: #ced5d9;
  --oks-green: #7ab800;
  --oks-green-300: #90c42b;
  --oks-green-200: #bcdb80;
  --oks-green-100: #d3e7aa;
  --oks-green-50: #e4f1cc;
  --oks-green-600: #517b00;
  --oks-blue: #0088ce;
  --oks-blue-50: #cce7f5;
  --oks-gray-50: #f9faf9;
  --oks-gray-100: #f5f6f5;
  --oks-gray-200: #f0f1f0;
  --oks-gray-300: #e7e8e7;
  --oks-gray-400: #e2e4e2;
  --oks-gray-600: #979897;
  --oks-danger: #b20000;
  --oks-danger-bg: #fceaea;
  --oks-radius-sm: 0.25rem;
  --oks-radius: 0.5rem;
  --oks-radius-md: 1rem;
  --oks-radius-lg: 1.5rem;
  --oks-radius-full: 9999px;
  --oks-shadow-sm: 0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a;
  --oks-shadow-md: 0 4px 8px -2px #4b4c4b1a, 0 2px 4px -2px #4b4c4b0f;
  --oks-shadow-xl: 0 20px 24px -4px #4b4c4b1a, 0 8px 8px -4px #4b4c4b0a;
  --oks-font:
    "Instrument Sans",
    "Inter",
    "asapregular",
    system-ui,
    -apple-system,
    "Segoe UI",
    Roboto,
    sans-serif;
  --oks-ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
  color: var(--oks-navy);
  font-family: var(--oks-font);
  font-size: 16px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
:host * {
  box-sizing: border-box;
}
.oks-accent {
  flex: 0 0 auto;
  height: 4px;
  background:
    linear-gradient(
      90deg,
      var(--oks-green) 0%,
      var(--oks-green-300) 35%,
      var(--oks-blue) 100%);
}
.oks-main {
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 6fr);
  align-items: stretch;
}
.oks-brand {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 4rem 4rem 6rem;
  background:
    linear-gradient(
      180deg,
      var(--oks-gray-50) 0%,
      var(--oks-gray-200) 100%);
  border-right: 1px solid var(--oks-gray-300);
}
.oks-brand__content {
  position: relative;
  z-index: 1;
  max-width: 30rem;
  margin-left: auto;
}
.oks-brand__logo {
  display: inline-flex;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1.25rem 1.5rem;
  border-radius: var(--oks-radius-md);
  background-color: #fff;
  box-shadow: var(--oks-shadow-sm);
  outline: none;
  transition: box-shadow 0.2s var(--oks-ease);
}
.oks-brand__logo img {
  display: block;
  height: 104px;
  width: auto;
}
.oks-brand__logo:hover {
  box-shadow: var(--oks-shadow-md);
}
.oks-brand__logo:focus-visible {
  box-shadow: 0 0 0 3px var(--oks-green-200);
}
.oks-brand__eyebrow {
  margin: 0 0 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.125em;
  text-transform: uppercase;
  color: var(--oks-green-600);
}
.oks-brand__title {
  margin: 0 0 1rem;
  font-size: 2.5rem;
  line-height: 1.1;
  letter-spacing: -1px;
  font-weight: 700;
  color: var(--oks-navy);
}
.oks-brand__lead {
  margin: 0 0 2rem;
  max-width: 26rem;
  font-size: 1.125rem;
  line-height: 1.63;
  color: var(--oks-slate-300);
}
.oks-brand__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}
.oks-brand__list li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.9375rem;
  color: var(--oks-slate-300);
}
.oks-brand__list svg {
  flex: 0 0 auto;
  width: 1.375rem;
  height: 1.375rem;
  margin-top: 0.0625rem;
  padding: 0.25rem;
  border-radius: var(--oks-radius-full);
  background-color: var(--oks-green-50);
  fill: none;
  stroke: var(--oks-green-600);
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.oks-brand__motif {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  width: 100%;
  height: 8.5rem;
  pointer-events: none;
}
.oks-brand__motif .motif-green {
  fill: var(--oks-green);
  opacity: 0.14;
}
.oks-brand__motif .motif-blue {
  fill: var(--oks-blue);
  opacity: 0.14;
}
.oks-panel {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4rem;
  background-color: #fff;
}
.oks-card {
  width: 100%;
  max-width: 25rem;
}
.oks-card__head {
  margin-bottom: 2rem;
}
.oks-card__head h1 {
  margin: 0 0 0.5rem;
  font-family: var(--oks-font);
  font-size: 1.875rem;
  line-height: 1.2;
  letter-spacing: -0.5px;
  font-weight: 700;
  color: var(--oks-navy);
  text-align: left;
  padding: 0;
}
.oks-card__sub {
  margin: 0;
  font-size: 0.9375rem;
  color: var(--oks-slate-200);
}
.oks-card__foot {
  margin: 1.75rem 0 0;
  font-size: 0.875rem;
  color: var(--oks-slate-200);
  text-align: center;
}
.oks-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  margin-bottom: 1.25rem;
  padding: 0.875rem 1rem;
  border-radius: var(--oks-radius);
  font-size: 0.875rem;
  line-height: 1.45;
}
.oks-alert svg {
  flex: 0 0 auto;
  width: 1.125rem;
  height: 1.125rem;
  margin-top: 0.0625rem;
  fill: none;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.oks-alert--error {
  background-color: var(--oks-danger-bg);
  color: var(--oks-danger);
}
.oks-alert--error svg {
  stroke: var(--oks-danger);
}
.oks-alert--success {
  background-color: var(--oks-green-50);
  color: var(--oks-green-600);
}
.oks-alert--success svg {
  stroke: var(--oks-green-600);
  stroke-width: 2.2;
}
.oks-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.oks-field {
  display: flex;
  flex-direction: column;
}
.oks-label {
  display: block;
  margin: 0 0 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--oks-navy);
}
.oks-label-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
}
.oks-label-row .oks-label {
  margin-bottom: 0.5rem;
}
.oks-input-wrap {
  position: relative;
  display: block;
}
.oks-input {
  width: 100%;
  height: 3.25rem;
  padding: 0 1rem;
  border: 1px solid var(--oks-gray-400);
  border-radius: var(--oks-radius);
  background-color: #fff;
  font-family: var(--oks-font);
  font-size: 1rem;
  font-weight: 400;
  line-height: normal;
  color: var(--oks-navy);
  outline: none;
  transition: border-color 0.2s var(--oks-ease), box-shadow 0.2s var(--oks-ease);
}
.oks-input::placeholder {
  color: var(--oks-slate-100);
  opacity: 1;
}
.oks-input:hover:not(:disabled) {
  border-color: var(--oks-slate-100);
}
.oks-input:focus {
  border-color: var(--oks-green);
  box-shadow: 0 0 0 3px var(--oks-green-200);
}
.oks-input:disabled {
  background-color: var(--oks-gray-100);
  color: var(--oks-slate-200);
  cursor: not-allowed;
}
.oks-input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
  -webkit-text-fill-color: var(--oks-navy);
}
.oks-input--action {
  padding-right: 3rem;
}
.oks-input--error {
  border-color: var(--oks-danger);
}
.oks-input--error:focus {
  border-color: var(--oks-danger);
  box-shadow: 0 0 0 3px rgba(178, 0, 0, 0.15);
}
.oks-reveal {
  position: absolute;
  top: 50%;
  right: 0.375rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: 0;
  border-radius: var(--oks-radius-full);
  background-color: transparent;
  color: var(--oks-slate-200);
  cursor: pointer;
  transition: background-color 0.2s var(--oks-ease), color 0.2s var(--oks-ease);
}
.oks-reveal svg {
  width: 1.125rem;
  height: 1.125rem;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.oks-reveal {
}
.oks-reveal .oks-reveal__slash {
  display: none;
}
.oks-reveal.oks-reveal--on .oks-reveal__slash {
  display: block;
}
.oks-reveal:hover {
  background-color: var(--oks-gray-200);
  color: var(--oks-navy);
}
.oks-reveal:focus-visible {
  outline: none;
  color: var(--oks-navy);
  box-shadow: 0 0 0 3px var(--oks-green-200);
}
.oks-error {
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  line-height: 1.4;
  color: var(--oks-danger);
  text-align: left;
}
.oks-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;
  min-height: 3.25rem;
  margin-top: 0.25rem;
  padding: 0.875rem 1.5rem;
  border: 0;
  border-radius: var(--oks-radius-full);
  font-family: var(--oks-font);
  font-size: 1rem;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition:
    background-color 0.2s var(--oks-ease),
    color 0.2s var(--oks-ease),
    box-shadow 0.2s var(--oks-ease);
}
.oks-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--oks-green-200);
}
.oks-btn--primary {
  background-color: var(--oks-green);
  color: var(--oks-navy);
}
.oks-btn--primary:hover:not(:disabled),
.oks-btn--primary:active:not(:disabled) {
  background-color: var(--oks-navy);
  color: var(--oks-green);
}
.oks-btn--primary:disabled {
  background-color: var(--oks-green-200);
  color: var(--oks-slate-300);
  cursor: not-allowed;
}
.oks-link {
  display: inline;
  padding: 0;
  border: 0;
  background: none;
  font-family: var(--oks-font);
  font-size: inherit;
  font-weight: 600;
  color: var(--oks-blue);
  cursor: pointer;
  border-bottom: 1px solid transparent;
  transition: color 0.2s var(--oks-ease), border-color 0.2s var(--oks-ease);
}
.oks-link:hover {
  color: var(--oks-navy);
  border-bottom-color: currentColor;
}
.oks-link:focus-visible {
  outline: none;
  color: var(--oks-navy);
  border-radius: var(--oks-radius-sm);
  box-shadow: 0 0 0 3px var(--oks-green-200);
}
.oks-link--sm {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--oks-slate-200);
}
.oks-divider {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1.75rem 0;
  color: var(--oks-slate-100);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.125em;
}
.oks-divider::before,
.oks-divider::after {
  content: "";
  flex: 1 1 auto;
  height: 1px;
  background-color: var(--oks-gray-300);
}
.oks-google {
  display: flex;
  justify-content: center;
}
.oks-google #google-button {
  display: flex;
  justify-content: center;
  min-height: 44px;
}
.oks-spinner {
  display: inline-block;
  width: 1.125rem;
  height: 1.125rem;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: oks-spin 0.7s linear infinite;
}
.oks-spinner--dark {
  color: var(--oks-green-600);
}
@keyframes oks-spin {
  to {
    transform: rotate(360deg);
  }
}
.oks-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 0;
  font-size: 0.9375rem;
  color: var(--oks-slate-200);
}
.oks-footer {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem 2.5rem;
  padding: 1.5rem 3rem;
  border-top: 1px solid var(--oks-gray-300);
  background-color: var(--oks-gray-50);
  font-size: 0.8125rem;
  color: var(--oks-slate-200);
}
.oks-footer p {
  margin: 0;
}
.oks-footer__name {
  font-weight: 600;
  color: var(--oks-slate-300);
}
.oks-footer__contact {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
}
.oks-footer__contact a {
  color: var(--oks-slate-300);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color 0.2s var(--oks-ease), border-color 0.2s var(--oks-ease);
}
.oks-footer__contact a:visited {
  color: var(--oks-slate-300) !important;
}
.oks-footer__contact a:hover {
  color: var(--oks-navy) !important;
  border-bottom-color: currentColor;
}
.oks-footer__contact a:focus-visible {
  outline: none;
  border-radius: var(--oks-radius-sm);
  box-shadow: 0 0 0 3px var(--oks-green-200);
}
.oks-footer__copy {
  color: var(--oks-slate-100);
}
@media (max-width: 1280px) {
  .oks-brand {
    padding: 3rem 3rem 5rem;
  }
  .oks-brand__title {
    font-size: 2.125rem;
  }
  .oks-panel {
    padding: 3rem;
  }
}
@media (max-width: 1023px) {
  .oks-main {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto 1fr;
  }
  .oks-brand {
    align-items: flex-start;
    padding: 2.5rem 2rem 3rem;
    border-right: 0;
    border-bottom: 1px solid var(--oks-gray-300);
  }
  .oks-brand__content {
    margin-left: 0;
    max-width: 34rem;
  }
  .oks-brand__logo {
    margin-bottom: 1.25rem;
  }
  .oks-brand__logo img {
    height: 76px;
  }
  .oks-brand__title {
    font-size: 1.75rem;
  }
  .oks-brand__lead {
    margin-bottom: 0;
    font-size: 1rem;
  }
  .oks-brand__list {
    display: none;
  }
  .oks-brand__motif {
    height: 2.75rem;
    opacity: 0.85;
  }
  .oks-panel {
    align-items: flex-start;
    justify-content: center;
    padding: 2.5rem 2rem 3rem;
  }
  .oks-card {
    max-width: 25rem;
  }
}
@media (max-width: 639px) {
  .oks-brand {
    padding: 1.75rem 1.25rem 2.25rem;
  }
  .oks-brand__logo {
    margin-bottom: 1rem;
  }
  .oks-brand__logo img {
    height: 64px;
  }
  .oks-brand__title {
    font-size: 1.5rem;
    letter-spacing: -0.5px;
  }
  .oks-brand__lead {
    font-size: 0.9375rem;
  }
  .oks-panel {
    padding: 2rem 1.25rem 2.5rem;
  }
  .oks-card__head {
    margin-bottom: 1.5rem;
  }
  .oks-card__head h1 {
    font-size: 1.625rem;
  }
  .oks-footer {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.25rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
/*# sourceMappingURL=login.component.css.map */
